(function () {
  function forceShowArrow(el, side) {
    if (!el) return;

    el.style.position = "absolute";
    el.style.top = "50%";
    el.style.left = side === "prev" ? "8px" : "auto";
    el.style.right = side === "next" ? "8px" : "auto";
    el.style.transform = "translateY(-50%)";
    el.style.margin = "0";
    el.style.padding = "0";
    el.style.zIndex = "9999";
    el.style.display = "flex";
    el.style.alignItems = "center";
    el.style.justifyContent = "center";
    el.style.pointerEvents = "auto";
    el.style.opacity = "1";
    el.style.visibility = "visible";
    el.style.width = "auto";
    el.style.minWidth = "auto";
    el.style.maxWidth = "none";
    el.style.height = "auto";
    el.style.minHeight = "auto";
    el.style.maxHeight = "none";

    const btn = el.querySelector("button");
    if (btn) {
      btn.style.minWidth = "40px";
      btn.style.minHeight = "40px";
      btn.style.width = "40px";
      btn.style.height = "40px";
      btn.style.lineHeight = "1";
      btn.style.borderRadius = "999px";
      btn.style.display = "inline-flex";
      btn.style.alignItems = "center";
      btn.style.justifyContent = "center";
      btn.style.background = "rgba(255,255,255,.92)";
      btn.style.boxShadow = "0 2px 8px rgba(0,0,0,.15)";
      btn.style.padding = "0";
      btn.style.margin = "0";

      if (!btn.dataset.iconInjected) {
        btn.innerHTML = side === "prev" ? "&#8249;" : "&#8250;";
        btn.dataset.iconInjected = "true";
      }

      btn.style.setProperty("--arrow-content", "''");
    }
  }

  function hideArrow(el) {
    if (!el) return;
    el.style.opacity = "0";
    el.style.visibility = "hidden";
    el.style.pointerEvents = "none";
  }

  function atEnds(swiper) {
    const idx = typeof swiper.activeIndex === "number" ? swiper.activeIndex : 0;
    const spv = typeof swiper.params.slidesPerView === "number" ? swiper.params.slidesPerView : 1;
    const total = swiper.slides ? swiper.slides.length : 0;

    const isBeginning = swiper.isBeginning || idx <= 0;
    const lastStart = Math.max(0, total - Math.ceil(spv));
    const isEnd = swiper.isEnd || idx >= lastStart;

    return { isBeginning, isEnd, total, spv };
  }

  // NUOVA FUNZIONE: Inizializza una singola istanza
  function initSingleMulticolumn(wrapper, index) {
    const cs = getComputedStyle(wrapper);
    if (cs.position === "static") wrapper.style.position = "relative";

    const sectionId = wrapper.dataset.id;
    const perRow = Number(wrapper.dataset.perRow) || 1;
    const mobileR = Number(wrapper.dataset.mobile) || 1;
    const enableNavigation = (wrapper.dataset.navigation || "false") === "true";

    const swiperEl = wrapper.querySelector(".swiper");
    if (!swiperEl) return;

    // IMPORTANTE: Aggiungi classe unica per evitare conflitti
    const uniqueClass = `swiper-${index}-${Date.now()}`;
    swiperEl.classList.add(uniqueClass);

    const prevWrap = wrapper.querySelector(".multicolumn-button-prev");
    const nextWrap = wrapper.querySelector(".multicolumn-button-next");

    // Distruggi istanza esistente se presente
    if (swiperEl.swiper) {
      try {
        swiperEl.swiper.destroy(true, true);
      } catch (e) {
        console.warn('Error destroying swiper:', e);
      }
    }

    // Forza visibilità frecce
    forceShowArrow(prevWrap, "prev");
    forceShowArrow(nextWrap, "next");

    // Attendi un frame prima di inizializzare
    requestAnimationFrame(() => {
      try {
        const swiper = new Swiper(`.${uniqueClass}`, {
          loop: false,
          initialSlide: 0,
          longSwipesRatio: 0.1,
          slidesPerView: mobileR,
          allowTouchMove: true,
          speed: 1000,
          observer: true,
          observeParents: true,
          watchOverflow: true,
          uniqueNavElements: true, // IMPORTANTE
          breakpoints: {
            1100: {
              slidesPerView: perRow + 0.4,
            },
          },
          ...(enableNavigation && prevWrap && nextWrap
            ? {
                navigation: {
                  nextEl: nextWrap,
                  prevEl: prevWrap,
                },
              }
            : {}),
        });

        function updateArrows() {
          if (!(enableNavigation && prevWrap && nextWrap)) return;

          forceShowArrow(prevWrap, "prev");
          forceShowArrow(nextWrap, "next");

          const { isBeginning, isEnd, total, spv } = atEnds(swiper);

          if (isBeginning) hideArrow(prevWrap);
          if (isEnd) hideArrow(nextWrap);

          if (total && total <= spv) {
            hideArrow(prevWrap);
            hideArrow(nextWrap);
          }
        }

        // Eventi
        swiper.on("slideChange", updateArrows);
        swiper.on("resize", updateArrows);
        swiper.on("update", updateArrows);
        swiper.on("init", updateArrows);

        // Stato iniziale
        hideArrow(prevWrap);
        
        // Update multipli con delay
        setTimeout(updateArrows, 100);
        setTimeout(updateArrows, 300);
        setTimeout(updateArrows, 600);

      } catch (error) {
        console.error(`Error initializing swiper ${index}:`, error);
      }
    });
  }

  const multicolumnSlider = () => {
    const wrappers = Array.from(document.querySelectorAll(".multicolumn__wrapper"));
    if (wrappers.length === 0) return;

    // Inizializza ogni wrapper con delay progressivo
    wrappers.forEach((wrapper, index) => {
      setTimeout(() => {
        initSingleMulticolumn(wrapper, index);
      }, index * 150); // 0ms, 150ms, 300ms...
    });
  };

  document.addEventListener("DOMContentLoaded", multicolumnSlider);
  document.addEventListener("shopify:section:load", multicolumnSlider);
})();